import React from 'react'

const Header = () => {
  return (
    <header
    className="w3-container w3-red w3-center"
    style={{ padding: "128px 16px" }}
  >
    <h1 className="w3-margin w3-jumbo">START PAGE</h1>
    <p className="w3-xlarge">Template by w3.css</p>
    <button className="w3-button w3-black w3-padding-large w3-large w3-margin-top">
      Get Started
    </button>
  </header>
  )
}

export default Header